import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const LinkIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue157'}</MuiIcon>
        );
    })